import api from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    page: {
      title: '',
      content: '',
    },
    pages: [],
    loading: false,
  },
  getters: {
    page: state => state.page,
    pages: state => state.pages,
    loading: state => state.loading,
  },
  mutations: {
    SET_PAGE(state, page) {
      state.page = page
    },
    SET_PAGES(state, pages) {
      state.pages = pages
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
  },
  actions: {
    async findAll({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true)
        api.get('pages')
          .then(({ data }) => {
            commit('SET_PAGES', data)
            resolve(data)
          })
          .catch(error => reject(error))
          .finally(() => commit('SET_LOADING', false))
      })
    },
    async findById({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true)
        api.get(`pages/${id}`)
          .then(({ data }) => {
            commit('SET_PAGE', data)
            resolve(data)
          })
          .catch(error => reject(error))
          .finally(() => commit('SET_LOADING', false))
      })
    },
    async create({ commit, dispatch }, page) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true)
        api.post('pages', page)
          .then(({ data }) => {
            commit('SET_PAGE', data)
            dispatch('findAll')
            resolve(data)
          })
          .catch(error => reject(error))
          .finally(() => commit('SET_LOADING', false))
      })
    },
    async update({ commit, dispatch }, {id, page}) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true)
        api.put(`pages/${id}`, page)
          .then(({ data }) => {
            dispatch('findAll')
            resolve(data)
          })
          .catch(error => reject(error))
          .finally(() => commit('SET_LOADING', false))
      })
    },
    async delete({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true)
        api.delete(`pages/${id}`)
          .then(() => {
            dispatch('findAll')
            resolve(true)
          })
          .catch(error => reject(error))
          .finally(() => commit('SET_LOADING', false))
      })
    },
    resertDataPages({ commit }) {
      commit('SET_PAGE', null)
      commit('SET_PAGES', [])
      commit('SET_LOADING', false)
    },
  },
}
